import React from 'react';
import { Tabs, Typography } from 'antd';
import useRecibos from './useRecibos';

const { Title } = Typography;

const Recibos: React.FC = () => {

    const {
        activeKeyTabs,
        setActiveKeyTabs,
        items,
        userCan,
    } = useRecibos();

    if (!userCan('manage_receipts')) {
        return (
            <>
                <Title level={3}>Você não tem permissão para acessar essa página.</Title>
            </>
        );
    }

    return (
        <>
            <Tabs
                defaultActiveKey="cadastrarRecibos"
                onTabClick={(activeKey) => {
                    setActiveKeyTabs(activeKey)
                }}
                activeKey={activeKeyTabs}
                destroyInactiveTabPane
                type="card"
                tabBarStyle={{
                    marginTop: 10
                }}
                items={items}
            />
        </>
    );
}

export default Recibos;
